import { render, staticRenderFns } from "./DepartmentLimitRulesB2b.vue?vue&type=template&id=6250f9c3"
import script from "./DepartmentLimitRulesB2b.vue?vue&type=script&lang=js"
export * from "./DepartmentLimitRulesB2b.vue?vue&type=script&lang=js"
import style0 from "./DepartmentLimitRulesB2b.vue?vue&type=style&index=0&id=6250f9c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports